import React from 'react';
import { FiCheckCircle, FiShield, FiZap, FiStar, FiExternalLink, FiUserPlus, FiDownload } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const PromotionPage = ({ pdfUrl, docName }) => {
    const navigate = useNavigate();
    const hasToken = !!localStorage.getItem('authToken');

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
            padding: '40px 20px',
            fontFamily: "'Inter', sans-serif"
        }}>
            <div style={{
                maxWidth: '900px',
                width: '100%',
                backgroundColor: 'white',
                borderRadius: '32px',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
                overflow: 'hidden',
                border: '1px solid rgba(255, 255, 255, 0.8)'
            }}>
                {/* Header Hero */}
                <div style={{
                    background: '#000000',
                    padding: '80px 40px',
                    color: 'white',
                    position: 'relative',
                    textAlign: 'center'
                }}>
                    {/* Animated Background Element */}
                    <div style={{
                        position: 'absolute',
                        top: '-50px',
                        right: '-50px',
                        width: '200px',
                        height: '200px',
                        background: 'radial-gradient(circle, #FFD600 0%, transparent 70%)',
                        opacity: 0.15,
                        filter: 'blur(40px)'
                    }}></div>

                    <div style={{ position: 'relative', zIndex: 1 }}>
                        <div style={{
                            backgroundColor: '#10b981',
                            width: '100px',
                            height: '100px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '50px',
                            color: 'white',
                            margin: '0 auto 30px',
                            boxShadow: '0 0 30px rgba(16, 185, 129, 0.5)',
                            border: '4px solid rgba(255, 255, 255, 0.1)'
                        }}>
                            <FiCheckCircle />
                        </div>
                        <h1 style={{
                            fontSize: '42px',
                            fontWeight: '900',
                            marginBottom: '20px',
                            background: 'linear-gradient(to right, #ffffff, #94a3b8)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}>
                            Success! Document Signed
                        </h1>
                        <p style={{ fontSize: '20px', color: '#94a3b8', maxWidth: '650px', margin: '0 auto', lineHeight: 1.6 }}>
                            You have successfully signed this document using <span style={{ color: '#FFD600', fontWeight: '800' }}>SignTada</span>.
                            The digital signature is secure and legally binding.
                        </p>
                    </div>
                </div>

                {/* Features & Promotion */}
                <div style={{ padding: '60px 50px' }}>
                    <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                        <span style={{
                            backgroundColor: '#fffbeb',
                            color: '#b45309',
                            padding: '8px 20px',
                            borderRadius: '99px',
                            fontSize: '14px',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            Limited Offer: 1 Free Credit
                        </span>
                        <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#111827', marginTop: '20px' }}>
                            Why people love SignTada
                        </h2>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '40px',
                        marginBottom: '60px'
                    }}>
                        <div style={{
                            padding: '30px',
                            borderRadius: '24px',
                            background: '#f8fafc',
                            transition: 'transform 0.3s ease',
                            border: '1px solid #f1f5f9'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                backgroundColor: '#FFD600',
                                borderRadius: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '24px',
                                color: '#000',
                                marginBottom: '20px'
                            }}><FiShield /></div>
                            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '12px', color: '#1e293b' }}>Enterprise Security</h3>
                            <p style={{ fontSize: '15px', color: '#64748b', lineHeight: 1.6 }}>Bank-grade encryption ensure your documents are protected and tamper-proof at all times.</p>
                        </div>

                        <div style={{
                            padding: '30px',
                            borderRadius: '24px',
                            background: '#f8fafc',
                            transition: 'transform 0.3s ease',
                            border: '1px solid #f1f5f9'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                backgroundColor: '#FFD600',
                                borderRadius: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '24px',
                                color: '#000',
                                marginBottom: '20px'
                            }}><FiZap /></div>
                            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '12px', color: '#1e293b' }}>Intuitive Flow</h3>
                            <p style={{ fontSize: '15px', color: '#64748b', lineHeight: 1.6 }}>An effortless signing experience that eliminates friction and speeds up your deals.</p>
                        </div>

                        <div style={{
                            padding: '30px',
                            borderRadius: '24px',
                            background: '#f8fafc',
                            transition: 'transform 0.3s ease',
                            border: '1px solid #f1f5f9'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                backgroundColor: '#FFD600',
                                borderRadius: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '24px',
                                color: '#000',
                                marginBottom: '20px'
                            }}><FiStar /></div>
                            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '12px', color: '#1e293b' }}>Freemium Model</h3>
                            <p style={{ fontSize: '15px', color: '#64748b', lineHeight: 1.6 }}>Start for free and only pay for what you need. Get 1 free credit automatically upon signup.</p>
                        </div>
                    </div>

                    {/* CTA Section */}
                    <div style={{
                        background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
                        borderRadius: '28px',
                        padding: '50px 40px',
                        textAlign: 'center',
                        color: 'white',
                        boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.3)'
                    }}>
                        <h3 style={{ fontSize: '28px', fontWeight: '800', marginBottom: '15px' }}>
                            Start using SignTada today
                        </h3>
                        <p style={{ fontSize: '18px', color: '#94a3b8', marginBottom: '35px' }}>
                            Join thousands of businesses that trust us with their signatures.
                        </p>

                        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                            <a
                                href="https://signtada.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    background: '#FFD600',
                                    color: '#000',
                                    padding: '16px 36px',
                                    borderRadius: '16px',
                                    fontSize: '18px',
                                    fontWeight: '800',
                                    textDecoration: 'none',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 10px 20px -5px rgba(255, 214, 0, 0.5)'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-3px)';
                                    e.currentTarget.style.boxShadow = '0 15px 25px -5px rgba(255, 214, 0, 0.6)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 10px 20px -5px rgba(255, 214, 0, 0.5)';
                                }}
                            >
                                Visit SignTada <FiExternalLink />
                            </a>

                            {!hasToken && (
                                <button
                                    onClick={() => navigate('/login')}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        background: 'rgba(255, 255, 255, 0.1)',
                                        color: '#fff',
                                        padding: '16px 36px',
                                        borderRadius: '16px',
                                        fontSize: '18px',
                                        fontWeight: '800',
                                        border: '1px solid rgba(255, 255, 255, 0.2)',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
                                    onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
                                >
                                    Create Account <FiUserPlus />
                                </button>
                            )}
                        </div>
                    </div>

                    <div style={{ marginTop: '50px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
                        {pdfUrl && (
                            <a
                                href={pdfUrl}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#2563eb',
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    textDecoration: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '10px',
                                    background: '#eff6ff',
                                    border: '1px solid #dbeafe',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.background = '#dbeafe'}
                                onMouseOut={(e) => e.currentTarget.style.background = '#eff6ff'}
                            >
                                <FiDownload /> Download Signed Copy
                            </a>
                        )}

                        {hasToken ? (
                            <button
                                onClick={() => navigate('/dashboard')}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: '#64748b',
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    textDecoration: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.color = '#000'}
                                onMouseOut={(e) => e.currentTarget.style.color = '#64748b'}
                            >
                                Continue to your Dashboard →
                            </button>
                        ) : (
                            <p style={{ color: '#94a3b8', fontSize: '15px' }}>
                                <span style={{ fontSize: '13px', opacity: 0.8 }}>(You can safely close this window)</span>
                            </p>
                        )}
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '40px', textAlign: 'center', color: '#94a3b8', fontSize: '14px' }}>
                <p>© 2025 SignTada. The modern standard for digital signatures.</p>
                <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', marginTop: '10px' }}>
                    <button type="button" style={{ color: 'inherit', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', font: 'inherit' }}>Privacy Policy</button>
                    <button type="button" style={{ color: 'inherit', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', font: 'inherit' }}>Terms of Service</button>
                    <button type="button" style={{ color: 'inherit', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', font: 'inherit' }}>Security</button>
                </div>
            </div>
        </div>
    );
};

export default PromotionPage;
